module.exports = __webpack_public_path__ + "static/images/right-arrow.e68d0180f64f8f1cdf4c07b32411605a.svg";